import { DELIVERY_COLLECT, DELIVERY_HOME } from '../constants'

export const PRODUCTS = [
    {
        prdctCd: DELIVERY_COLLECT,
        prdctNameKey: 'subscription.purchase.delivery.pickup',
        prdctLongDesc: '',
        ratePlans: [
            {
                name: '',
                price: 0.0,
                ratePlanId: 'collect',
                queryParams: '',
                //Following value is needed for API
                credentialDistribution: {
                    code: 'CREDDISTRIBUTION',
                    value: 'LOCATION',
                },
            },
        ],
    },
    {
        prdctCd: DELIVERY_HOME,
        prdctNameKey: 'subscription.purchase.delivery.home',
        prdctLongDesc: '',
        ratePlans: [
            {
                name: 'Express',
                price: 5.0,
                ratePlanId: 'express',
                queryParams: '&shipExpress=true',
                credentialDistribution: {
                    code: 'CREDDISTRIBUTION',
                    value: 'EXPMAIL',
                },
            },
            {
                name: 'Standard',
                price: 2.0,
                ratePlanId: 'standard',
                queryParams: '&shipRegular=true',
                credentialDistribution: {
                    code: 'CREDDISTRIBUTION',
                    value: 'MAIL',
                },
            },
        ],
    },
]

export const SET_PURCHASE_DATA = 'SET_PURCHASE_DATA'

export const GET_SUBSCRIPTION_LOCATION = 'GET_SUBSCRIPTION_LOCATION'
export const SET_SUBSCRIPTION_LOCATION = 'SET_SUBSCRIPTION_LOCATION'

export const GET_LOCATION_RATES = 'GET_LOCATION_RATES'
export const SET_LOCATION_RATES = 'SET_LOCATION_RATES'

export const GET_ORDER_SUMMARY = 'GET_ORDER_SUMMARY'
export const SET_ORDER_SUMMARY = 'SET_ORDER_SUMMARY'

export const GET_TERMS_AND_CONDITIONS = 'GET_TERMS_AND_CONDITIONS'
export const SET_TERMS_AND_CONDITIONS = 'SET_TERMS_AND_CONDITIONS'

export const BUY_SUBSCRIPTION = 'BUY_SUBSCRIPTION'

export const ADD_RATE_TO_WAITLIST = 'ADD_RATE_TO_WAITLIST'

export const GET_COLLECT_ADDRESS = 'GET_COLLECT_ADDRESS'
export const SET_COLLECT_ADDRESS = 'SET_COLLECT_ADDRESS'

export const SUBSCRIPTION_LOCATION_PENDING = 'subscriptionLocation'
export const LOCATION_RATES_PENDING = 'locationRates'
export const TERMS_CONDITIONS_PENDING = 'termsConditionsLoading'
export const SUBSCRIPTION_PURCHASE_PENDING = 'subscriptionPurchaseBuy'
export const ADD_RATE_TO_WAITLIST_PENDING = 'addRateToWaitList'

export const GET_COLLECT_ADDRESS_PENDING = 'getCollectAddress'
